import type { VideoStage } from '@ayub/shared'
import { VIDEO_STAGE_LABELS } from '@ayub/shared'
import { cn } from '@/lib/utils'
import { VIDEO_STAGE_META } from './stageMeta'

/** Jadval "Bosqich" ustuni va kartochka sarlavhasidagi bosqich belgisi — ikonka + matn birga. */
export function VideoStageBadge({ stage, className }: { stage: VideoStage; className?: string }) {
  const meta = VIDEO_STAGE_META[stage]
  const Icon = meta.icon
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-badge px-2 py-0.5 text-xs font-medium',
        meta.textClass,
        meta.subtleClass,
        className,
      )}
    >
      <Icon size={12} aria-hidden="true" />
      {VIDEO_STAGE_LABELS[stage]}
    </span>
  )
}
